import React from "react";
import PropTypes from "prop-types";
import styles from "./MenuItem.module.css";

export function MenuItem({ onClick, label, isActive, badgeCount = 0 }) {
  return (
    <div className={styles.container}>
      <span onClick={onClick} className={isActive ? styles.active : ""}>
        <div className={styles.label}>
          <span className={styles.labelText} data-text={label}>
            {label}
          </span>
          {badgeCount > 0 && (
            <span className={styles.badge}>
              {badgeCount > 99 ? "99+" : badgeCount}
            </span>
          )}
        </div>
      </span>
    </div>
  );
}

MenuItem.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  isActive: PropTypes.bool,
  badgeCount: PropTypes.number,
};

export default MenuItem;
